import { render } from "./page-brokerage.vue?vue&type=template&id=1286bec0"
import script from "./page-brokerage.js?vue&type=script&lang=js"
export * from "./page-brokerage.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__